import clsx from 'clsx';
import * as React from 'react';

import { Typography } from '@/shared/components/atoms';

type WidgetItemProps = {
  title: string;
  value?: string | number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any;
  TitleTooltip?: JSX.Element;
  ValueTooltip?: JSX.Element;
};
interface Props {
  data: WidgetItemProps;
  valueColor?: string;
}

const WidgetItem: React.FC<Props> = ({ data, valueColor }) => {
  const { value, title, icon: Icon } = data;

  return (
    <div className='flex w-full  items-center gap-16 rounded-2xl bg-white px-24 py-16'>
      {/* ******* icon ****** */}
      <div className='text-32'>
        <Icon />
      </div>
      {/* ********** content ********* */}
      <div>
        {/* **** title **** */}
        <div className='flex items-center gap-8'>
          <Typography
            variant='subtitle2'
            weight='medium'
            className='text-surface-10  first-letter:uppercase'
          >
            {title}
          </Typography>
          {data?.TitleTooltip && data.TitleTooltip}
        </div>

        {/* ****** value **** */}
        <div className='flex items-center gap-8'>
          <Typography
            variant='h2'
            weight='bold'
            className={clsx(
              'flex items-center gap-8',
              valueColor ? valueColor : 'text-primary-400'
            )}
          >
            {value === 0 ? 0 : value || '-'}
          </Typography>
          {data?.ValueTooltip && data.ValueTooltip}
        </div>
      </div>
    </div>
  );
};
export default WidgetItem;
